import { render, staticRenderFns } from "./DetailedList.vue?vue&type=template&id=425a503a&"
import script from "./DetailedList.vue?vue&type=script&lang=js&"
export * from "./DetailedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports